import React from 'react';
export function Hero() {
  return <section className="relative bg-gradient-to-b from-[#100000] to-[#0a0a0a] pt-[28px] px-5 pb-[20px] text-center after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[1px] after:bg-gradient-to-r after:from-transparent after:via-brand-red after:to-transparent" data-id="element-91">
      <div className="max-w-[860px] mx-auto px-5" data-id="element-92">
        <div className="inline-block bg-transparent border-[1.5px] border-brand-red text-brand-red font-montserrat font-bold tracking-[3px] uppercase py-1.5 px-[18px] rounded-[3px] mb-[14px] text-[8px]" data-id="element-93">
          El Codigo del Control -Rendimiento Masculino
        </div>
        <h1 className="font-montserrat font-black text-brand-white uppercase tracking-[-1px] mb-2 text-[18px]" data-id="element-94">
          Más de 500.000 de Hombres Usaron el Método Kegel para{' '}
          <em className="not-italic text-brand-red" data-id="element-95">Durar Más</em> y Convertirse
          en el Hombre que Ella Nunca Va a Olvidar
        </h1>
      </div>
    </section>;
}